const UPDATES_PAGE_LINK = 'https://www.wix.com/release/notes';
const STATIC_IMAGE_SRC = '//static.wixstatic.com';

export { UPDATES_PAGE_LINK, STATIC_IMAGE_SRC };
